import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { theme } from './theme';
import Login from './pages/Login';
import Layout from './pages/Layout';
import Dashboard from './pages/Dashboard';
import Community from './pages/Community';
import Building from './pages/Building';
import Unit from './pages/Unit';
import Room from './pages/Room';
import User from './pages/User';
import Appointment from './pages/Appointment';

function App() {
  const token = localStorage.getItem('token');

  return (
    <ConfigProvider theme={theme} locale={zhCN}>
      <AntdApp>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              token ? <Layout /> : <Navigate to="/login" replace />
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="community" element={<Community />} />
            <Route path="building" element={<Building />} />
            <Route path="unit" element={<Unit />} />
            <Route path="room" element={<Room />} />
            <Route path="user" element={<User />} />
            <Route path="appointment" element={<Appointment />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
